"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var WithErrorHandler_1 = require("../../components/WithErrorHandler");
var baseModal_1 = __importDefault(require("./baseModal"));
var index_1 = require("../../utils/index");
var Index = function (props) {
    var titleRelate = react_1.useMemo(function () {
        return {
            mainTitle: (typeof props.titleRelate !== 'undefined' &&
                props.titleRelate.mainTitle) ||
                '立即咨询车型特惠',
            btnSubTitle: (typeof props.titleRelate !== 'undefined' &&
                props.titleRelate.btnSubTitle) ||
                '专业顾问给您提供厂商和经销商店铺实时优惠',
            btnMainTitle: (typeof props.titleRelate !== 'undefined' &&
                props.titleRelate.btnMainTitle) ||
                '立即咨询',
        };
    }, [JSON.stringify(props.titleRelate)]);
    var prodInfoRelate = react_1.useMemo(function () { return props.prodInfoRelate; }, [JSON.stringify(props.prodInfoRelate)]);
    var cityInfoRelate = react_1.useMemo(function () { return props.cityinfoRelate; }, [JSON.stringify(props.cityinfoRelate)]);
    var _a = __read(react_1.useState(), 2), prodInfo = _a[0], setProdInfo = _a[1];
    react_1.useEffect(function () {
        if (prodInfoRelate && prodInfoRelate.productId) {
            getProdInfo();
        }
    }, [prodInfoRelate, cityInfoRelate]);
    var getProdInfo = react_1.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var params, res, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    params = {
                        cityId: ((_a = cityInfoRelate === null || cityInfoRelate === void 0 ? void 0 : cityInfoRelate.defaultCityInfo) === null || _a === void 0 ? void 0 : _a.cityid) || 613,
                        productId: prodInfoRelate.productId,
                    };
                    return [4 /*yield*/, index_1.tools.getProdInfos(__assign({}, params))];
                case 1:
                    res = (_b.sent());
                    if (res.code === 0 && res.entity.data) {
                        setProdInfo(res.entity.data);
                    }
                    else {
                        throw res;
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _b.sent();
                    console.log('获取车型信息失败-->', err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [prodInfoRelate, cityInfoRelate]);
    var renderMidSlot = function () {
        if (prodInfo && prodInfo.preference) {
            return (react_1.default.createElement("div", { className: 'firm-wrap' },
                react_1.default.createElement("div", { className: 'firm-inner' },
                    prodInfo.preference.loanPreference && (react_1.default.createElement("div", { className: 'firm-inner-item' },
                        react_1.default.createElement("span", { className: 'firm-inner-item-tag' },
                            react_1.default.createElement("div", { className: 'item-tag-icon' }, "\u5206\u671F\u8D2D\u8F66"),
                            react_1.default.createElement("div", null, prodInfo.preference.loanPreference)))),
                    prodInfo.preference.pricePreference && (react_1.default.createElement("div", { className: 'firm-inner-item' },
                        react_1.default.createElement("span", { className: 'firm-inner-item-tag' },
                            react_1.default.createElement("div", { className: 'item-tag-icon' }, "\u7F6E\u6362\u8865\u8D34"),
                            react_1.default.createElement("div", null, prodInfo.preference.pricePreference)))))));
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    };
    return (react_1.default.createElement(baseModal_1.default, __assign({}, props, { titleRelate: __assign({}, titleRelate), prodInfoRelate: __assign({ showProdArea: true }, prodInfoRelate), midSlotNode: props.midSlotNode || renderMidSlot() })));
};
exports.default = WithErrorHandler_1.WithErrorHandler(react_1.memo(Index));
